/**
 * Shared booking validation utilities
 * Used across TourPage, GroupTourPage, OtherTour, TourPackagePage, AbroadPage
 */

// A guest limit that is null, undefined, empty or 0 is unset: no limit, as on the server.
const guestLimit = (value) => {
    if (value === null || value === undefined || value === '') return null;
    const n = Number(value);
    return Number.isFinite(n) && n !== 0 ? n : null;
};

export const validateBookingParams = (data, guestCount, childCount, selectedLanguage, startingTime, startDate, t) => {
    const translate = t || ((key) => key);
    const count = Number(guestCount) + Number(childCount);
    const guestMax = guestLimit(data?.guest_max);
    const guestMin = guestLimit(data?.guest_min);

    if (guestMax !== null && count > guestMax) {
        return {
            valid: false,
            message: `${translate('maxParticipants')} ${data?.guest_max}.`
        };
    }

    if (guestMin !== null && count < guestMin) {
        return {
            valid: false,
            message: `${translate('minParticipants')} ${data?.guest_min} ${translate('minParticipantsSuffix')}`
        };
    }

    if (!selectedLanguage) {
        return { valid: false, message: translate('pleaseChooseLanguage') };
    }

    if (!startingTime) {
        return { valid: false, message: translate('pleaseChooseStartingTime') };
    }

    if (!startDate) {
        return { valid: false, message: translate('pleaseChooseDate') };
    }

    return { valid: true };
};

export const calculateTourPrice = (data, guestCount, childCount) => {
    let result = 0;

    if (guestCount) {
        result += Number(guestCount) * Number(data?.price || 0);
    }

    if (childCount) {
        result += Number(childCount) * Number(data?.child_price || 0);
    }

    if (data?.discount) {
        const discountAmount = (result * Number(data.discount)) / 100;
        result -= discountAmount;
    }

    return Math.round(result * 100) / 100;
};
